import { inject, Injectable } from '@angular/core';
import { ProviderSetting } from '@app/core/services/api/API.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ProviderSettingService as ProviderSettingServiceApi } from '@app/core/api/services';

@Injectable({
    providedIn: 'root'
})
export class ProviderSettingService {
    private _providersSetting$ = new BehaviorSubject<ProviderSetting[]>([]);
    private _loading$ = new BehaviorSubject<boolean>(true);
    private _providerSettingServiceApi = inject(ProviderSettingServiceApi);

    private _isLoading = false;
    get loading$(): Observable<boolean> {
        return this._loading$.asObservable();
    }

    get providersSetting$(): Observable<ProviderSetting[]> {
        return this._providersSetting$.asObservable();
    }

    getProviderSettingById(
        id: string
    ): Observable<ProviderSetting | undefined> {
        const providersSetting = this._providersSetting$.getValue();
        return of(
            providersSetting.find(providerSetting => providerSetting.id === id)
        );
    }

    async listProviderSettings() {
        if (this._isLoading) {
            return;
        }

        const existingSettings = this._providersSetting$.getValue();
        if (existingSettings && existingSettings.length > 0) {
            return;
        }

        this._isLoading = true;
        try {
            this._loading$.next(true);
            const providersSetting = await this._providerSettingServiceApi.listProvidersSetting();
            this._providersSetting$.next(providersSetting);
        } catch (err) {
            this._providersSetting$.next([]);
        } finally {
            this._loading$.next(false);
            this._isLoading = false;
        }
    }
}
